export default __webpack_public_path__ + "static/media/sports06.c1f29158.png";